module.exports = __webpack_public_path__ + "img/desk3.cf2395d3.png";